import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import heroImg from "../assets/images/b1.webp";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Select from "react-select";
import "../assets/css/contact.css";

const tourOptions = [
  { value: "tadoba", label: "वाईल्डलाईफ अ‍ॅडव्हेंचर - ताडोबा व्याघ्र प्रकल्प", price: "₹20,000/-" },
  { value: "kashmir", label: "ट्युलिप स्पेशल ऑफबीट काश्मीर टूर", price: "₹20,500/-" },
  { value: "mowgli-camp", label: "मोगली समर कॅम्प", price: "₹8,000/-" },
  { value: "pawan-char-dham-yatra", label: "पावन चार धाम यात्रा २०२६", price: "₹46,000/-" },
  { value: "siddhagiri", label: "सिद्धगिरी कारागीर महोत्सव आणि कणेरी मठ दर्शन", price: "₹1,500/-" },
  {
    value: "kailas-mansarovar",
    label: "कैलास मानसरोवर यात्रा",
    price: "₹2,10,000/-"
  },
  {
    value: "valley-of-flowers",
    label: "🌸 Valley of Flowers Trek with Gypsy Club",
    price: "₹16,000/-"
  },
  {
    value: "pin-bhaba-pass",
    label: "🏔️ Pin Bhaba Pass Trek",
    price: "₹22,500/-"
  }
];

function Contact() {
  const location = useLocation();

  // Tour options


  // States
  const [selectedDate, setSelectedDate] = useState("");
  const [availableDates, setAvailableDates] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    selectedTours: [],
    message: ""
  });

  useEffect(() => {
    const state = location.state;

    if (state?.tour) {
      const matchingTour = tourOptions.find(option =>
        option.label.includes(state.tour)   // ✅ improved match
      );

      if (matchingTour) {
        setFormData(prev => ({
          ...prev,
          selectedTours: [matchingTour],
          message: `I'm interested in the "${matchingTour.label}" tour.\nTravel Date: ${state?.dates?.[0] || ""}\n\n`
        }));
      }

      if (state?.dates) {
        setAvailableDates(state.dates);
        setSelectedDate(state.dates[0]);
      }
    }

    const params = new URLSearchParams(location.search);
    const tourParam = params.get('tour');

    if (tourParam && !state?.tour) {
      const matchingTour = tourOptions.find(option =>
        option.label.includes(decodeURIComponent(tourParam))
      );

      if (matchingTour) {
        setFormData(prev => ({
          ...prev,
          selectedTours: [matchingTour],
          message: `I'm interested in the "${matchingTour.label}" tour.\n\n`
        }));
      }
    }

  }, [location]); // ✅ now valid (no warning)

  // Input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Tour select
  const handleTourChange = (selectedOptions) => {
    setFormData(prev => ({
      ...prev,
      selectedTours: selectedOptions || []
    }));
  };

  // Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const tourNames = formData.selectedTours
      .map(tour => tour.label)
      .join(", ");

    const totalPrice = formData.selectedTours
      .reduce((sum, tour) => {
        const price = parseInt(tour.price.replace(/[^0-9]/g, ''));
        return sum + (isNaN(price) ? 0 : price);
      }, 0);

    const whatsappMessage = `*New Tour Inquiry*%0A%0A
*Name:* ${formData.name}%0A
*Mobile:* ${formData.mobile}%0A
*Selected Tours:* ${tourNames}%0A
*Travel Date:* ${selectedDate || "Not specified"}%0A
*Total Estimated Cost:* ₹${totalPrice.toLocaleString()}%0A
*Message:* ${formData.message}%0A%0AThank you!`;

    window.open(`https://wa.me/919689938912?text=${whatsappMessage}`, '_blank');
  };



  return (
    <div>
      <Navbar />

      {/* Hero */}
      <div className="ftco-blocks-cover-1">
        <div
          className="contact-banner "
          style={{
            backgroundImage: `url(${heroImg})`,
          }}
        >
          <div className="banner-overlay"></div>

          <div className="container text-center banner-content">
            <div className="row justify-content-center">
              <div className="col-lg-8 col-md-10 col-12">
                <h1 className="banner-title animate-fade-up">
                  Get In Touch
                </h1>

                <p className="banner-subtitle animate-fade-up-delay">
                  Your journey begins with a message.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact */}
      <div className="site-section">
        <div className="container">

          <div className="row justify-content-center text-center mb-5">
            <div className="col-md-10">
              <h3>Contact Us</h3>
              <p className="text-muted">Fill the form and we'll get back to you shortly</p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 mb-5 position-relative" style={{ zIndex: 10 }}>

              <form onSubmit={handleSubmit}>

                {/* Name */}
                <input
                  type="text"
                  name="name"
                  className="form-control mb-3"
                  placeholder="Name *"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />

                {/* Mobile */}
                <input
                  type="tel"
                  name="mobile"
                  className="form-control mb-3"
                  placeholder="Mobile number *"
                  value={formData.mobile}
                  onChange={handleInputChange}
                  required
                />

                {/* Tour Select */}
                <Select
                  options={tourOptions}
                  value={formData.selectedTours}
                  onChange={handleTourChange}
                  isMulti
                  placeholder="Select Tours (you can select multiple)..."
                  className="mb-3"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#ddd',
                      '&:hover': { borderColor: '#1e88e5' }
                    })
                  }}
                />

                {/* Date Dropdown */}
                {availableDates.length > 0 && (
                  <select
                    className="form-control mb-3"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    required
                    style={{ cursor: "pointer" }}
                  >
                    <option value="">Select Travel Date *</option>
                    {availableDates.map((date, index) => (
                      <option key={index} value={date}>
                        {date}
                      </option>
                    ))}
                  </select>
                )}

                {/* Message */}
                <textarea
                  className="form-control mb-3"
                  name="message"
                  placeholder="Write your message. (e.g., number of people, special requirements)"
                  rows="5"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                />

                {/* Submit */}
                <button type="submit" className="btn btn-primary">
                  Send Message
                </button>


              </form>
            </div>

            {/* Contact Info */}
            <div className="col-lg-4 ml-auto">
              <div className="card shadow-sm border-0">
                <div className="card-body">
                  <h4 className="mb-4">Contact Info</h4>

                  <div className="mb-4">
                    <h6 className="mb-2">Phone Numbers:</h6>
                    <p className="mb-1">
                      <i className="bi bi-telephone-fill me-2 text-primary"></i>
                      <a href="tel:919689938912" className="text-decoration-none">9689938912</a>
                    </p>
                    <p>
                      <i className="bi bi-telephone-fill me-2 text-primary"></i>
                      <a href="tel:918484037008" className="text-decoration-none">8484037008</a>
                    </p>
                  </div>

                  <div className="mb-4">
                    <h6 className="mb-2">Email:</h6>
                    <p>
                      <i className="bi bi-envelope-fill me-2 text-primary"></i>
                      <a href="mailto:gypsycompanion@gmail.com">gypsycompanion@gmail.com</a>
                    </p>
                  </div>

                  <div className="mb-4">
                    <h6 className="mb-2">Address:</h6>
                    <p>
                      <i className="bi bi-geo-alt-fill me-2 text-primary"></i>
                      Pune, Maharashtra, India
                    </p>
                  </div>


                </div>
              </div>


            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Contact;